import { render, staticRenderFns } from "./SystemInfoConfig.vue?vue&type=template&id=0711d8fc&scoped=true&"
import script from "./SystemInfoConfig.vue?vue&type=script&lang=js&"
export * from "./SystemInfoConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0711d8fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0711d8fc')) {
      api.createRecord('0711d8fc', component.options)
    } else {
      api.reload('0711d8fc', component.options)
    }
    module.hot.accept("./SystemInfoConfig.vue?vue&type=template&id=0711d8fc&scoped=true&", function () {
      api.rerender('0711d8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/system/subconfig/SystemInfoConfig.vue"
export default component.exports